"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popper = Popper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var ReactDOM = _interopRequireWildcard(require("react-dom"));
var _popperFork = require("@cian/popper-fork");
var _clsx = _interopRequireDefault(require("clsx"));
var _usePopper = require("./usePopper");
var styles = _interopRequireWildcard(require("./styles.css"));
const _excluded = ["open", "anchorRef", "placement", "modifiers", "children", "portal"];
/* eslint-disable @typescript-eslint/no-explicit-any */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонента для рендера элемента спозиционированного относительно другого элемента
 *
 * @export
 * @param {IPopperProps} { open, anchorEl, children }
 * @returns
 */
function Popper(_ref) {
  let {
      open,
      anchorRef,
      placement,
      modifiers,
      children,
      portal
    } = _ref,
    divProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const host = typeof document !== 'undefined' ? document.body : null;
  const popper = (0, _usePopper.usePopper)({
    open,
    anchorRef,
    options: {
      placement,
      modifiers
    }
  });
  if (!host || !open) {
    return null;
  }
  const popperElement = /*#__PURE__*/React.createElement("div", (0, _extends2.default)({}, divProps, {
    className: (0, _clsx.default)(styles['popper'], divProps.className),
    ref: popper.ref
  }), children);
  return portal ? /*#__PURE__*/ReactDOM.createPortal(popperElement, host) : popperElement;
}
Popper.defaultProps = {
  modifiers: [_popperFork.FLIP],
  portal: true
};